module.exports = __webpack_public_path__ + "img/unionpay.715bb074.svg";